import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { SectionContainer, SectionSubHeader, SectionSubHeaderCont } from '../styles';
import EditSummaryButton from '../EditSummaryButton';
import { PAGES } from '../../../constants';
import { selectAdditionalInsureds, selectAreAnyBlanketAIItemsChecked } from '../../../selectors/application';

export default function AdditionalInsureds() {
  const additionalInsureds = useSelector(selectAdditionalInsureds);
  const hasSelectedBlanket = useSelector(selectAreAnyBlanketAIItemsChecked);

  const hasAddedIndividualAI = additionalInsureds.length > 0;
  const count = additionalInsureds.length;

  return (
    <SectionContainer>
      <SectionSubHeaderCont>
        <SectionSubHeader>Additional Insureds</SectionSubHeader>
        <EditButton page={PAGES.ADDITIONAL_INSUREDS} label="additional-insureds">
          Edit
        </EditButton>
      </SectionSubHeaderCont>
      <PlainCard>
        <CardText>
          {hasSelectedBlanket && hasAddedIndividualAI && (
            <>
              includes <span className="highlight">{`Blanket and (${count}) Additional Insured`}</span>
            </>
          )}
          {hasSelectedBlanket && !hasAddedIndividualAI && (
            <>
              includes <span className="highlight">Blanket Additional Insureds</span>
            </>
          )}
          {!hasSelectedBlanket && hasAddedIndividualAI && (
            <>
              includes <span className="highlight">{`(${count}) Additional Insured`}</span>
            </>
          )}
          {!hasSelectedBlanket && !hasAddedIndividualAI && 'None added'}
        </CardText>
      </PlainCard>
    </SectionContainer>
  );
}

const EditButton = styled(EditSummaryButton)`
  font-size: 13px;
  margin-top: 16px;
  gap: 6px;
`;

const PlainCard = styled.div`
  border-radius: 4px;
  border: 1px solid #d4d4dd;
  background: ${({ theme }) => theme.colors.neutral.special};
  padding: 20px 16px;
`;

const CardText = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.font.typeface.secondary};
  color: ${({ theme }) => theme.colors.neutral.dark};
  font-size: 16px;
  font-weight: 400;
  line-height: normal;

  .highlight {
    color: ${({ theme }) => theme.colors.tertiary.zero};
    font-weight: 600;
    line-height: 24px;
  }
`;
